/*
 *
 * Dataset constants
 *
 */
import { COL_AMOUNT, ROW_AMOUNT } from '@appspotr/app';
export var MAX_HEIGHT = 400;
export var MAX_WIDTH = 80;
/** this is the amount of times wider a component should be initially in landscape mode */
export var LANDSCAPE_RATIO = Math.floor((ROW_AMOUNT / 2 / COL_AMOUNT) * 100) / 100;
export var UPDATE_GROUPED_SELECTED_COMPONENTS = 'app/ColourPreview/UPDATE_GROUPED_SELECTED_COMPONENTS';
export var UPDATE_GROUP_SELECTION = 'app/ColourPreview/UPDATE_GROUP_SELECTION';
export var DROP_COMPONENT = 'app/ColourPreview/DROP_COMPONENT';
export var LOAD_LAYOUT_REQUEST = 'app/ColourPreview/LOAD_LAYOUT_REQUEST';
export var LOAD_LAYOUT_SUCCESS = 'app/ColourPreview/LOAD_LAYOUT_SUCCESS';
export var LOAD_LAYOUT_FAILURE = 'app/ColourPreview/LOAD_LAYOUT_FAILURE';
export var LOAD_STYLE_REQUEST = 'app/StylesPage/LOAD_STYLE_REQUEST';
export var LOAD_STYLE_SUCCESS = 'app/StylesPage/LOAD_STYLE_SUCCESS';
export var LOAD_STYLE_FAILURE = 'app/StylesPage/LOAD_STYLE_FAILURE';
export var SAVE_LAYOUT_REQUEST = 'app/ColourPreview/SAVE_LAYOUT_REQUEST';
export var SAVE_LAYOUT_SUCCESS = 'app/ColourPreview/SAVE_LAYOUT_SUCCESS';
export var SAVE_LAYOUT_FAILURE = 'app/ColourPreview/SAVE_LAYOUT_FAILURE';
export var SELECT_GRID_COMPONENT = 'app/ColourPreview/SELECT_GRID_COMPONENT';
export var REMOVE_GRID_COMPONENT = 'app/ColourPreview/REMOVE_GRID_COMPONENT';
export var CHANGE_BG_COLOR = 'app/ColourPreview/CHANGE_BG_COLOR';
export var CHANGE_BG_IMAGE = 'app/ColourPreview/CHANGE_BG_IMAGE';
export var TOGGLE_PORTRAIT = 'app/ColourPreview/TOGGLE_PORTRAIT';
export var CHANGE_DEVICE_SCALE = 'app/ColourPreview/CHANGE_DEVICE_SCALE';
export var SET_NAME = 'app/ColourPreview/SET_NAME';
export var OVERRIDE_STYLE = 'app/ColourPreview/OVERRIDE_STYLE';
export var ASSIGN_OUTPUT = 'app/ColourPreview/ASSIGN_OUTPUT';
export var ASSIGN_STATE = 'app/ColourPreview/ASSIGN_STATE';
export var ON_LAYOUT_CHANGE = 'app/ColourPreview/ON_LAYOUT_CHANGE';
export var CHANGE_PADDING = 'app/ColourPreview/CHANGE_PADDING';
export var CHANGE_COMPONENT_VALUE = 'app/ColourPreview/CHANGE_COMPONENT_VALUE';
export var CHANGE_COMPONENT_MIN_MAX_VALUE = 'app/ColourPreview/CHANGE_COMPONENT_MIN_MAX_VALUE';
export var CHANGE_COLOR = 'app/ColourPreview/CHANGE_COLOR';
export var LOCK_COMPONENT = 'app/ColourPreview/LOCK_COMPONENT';
export var ADD_IO = 'app/ColourPreview/ADD_IO';
export var OPEN_MODAL = 'app/ColourPreview/OPEN_MODAL';
export var CHANGE_CUSTOM_STYLES = 'app/ColourPreview/CHANGE_CUSTOM_STYLES';
export var EDIT_IO = 'app/ColourPreview/EDIT_IO';
export var REMOVE_IO = 'app/ColourPreview/REMOVE_IO';
export var LOAD_FOLDERS_REQUEST = 'app/ColourPreview/LOAD_FOLDERS_REQUEST';
export var LOAD_FOLDERS_SUCCESS = 'app/ColourPreview/LOAD_FOLDERS_SUCCESS';
export var LOAD_FOLDERS_FAILURE = 'app/ColourPreview/LOAD_FOLDERS_FAILURE';
export var LOAD_FILES_REQUEST = 'app/ColourPreview/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/ColourPreview/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/ColourPreview/LOAD_FILES_FAILURE';
export var GET_DATASET_REQUEST = 'app/ColourPreview/GET_DATASET_REQUEST';
export var GET_DATASET_SUCCESS = 'app/ColourPreview/GET_DATASET_SUCCESS';
export var GET_DATASET_FAILURE = 'app/ColourPreview/GET_DATASET_FAILURE';
export var GET_DATASET_FIELDS_REQUEST = 'app/ColourPreview/GET_DATASET_FIELDS_REQUEST';
export var GET_DATASET_FIELDS_SUCCESS = 'app/ColourPreview/GET_DATASET_FIELDS_SUCCESS';
export var GET_DATASET_FIELDS_FAILURE = 'app/ColourPreview/GET_DATASET_FIELDS_FAILURE';
export var RESET_BG_COLOR = 'app/ColourPreview/RESET_BG_COLOR';
export var RESET_BG_IMAGE = 'app/ColourPreview/RESET_BG_IMAGE';
export var OPEN_COMPONENT_LIST = 'app/ColourPreview/SHOW_COMPONENT_LIST';
export var CLOSE_COMPONENT_LIST = 'app/ColourPreview/CLOSE_COMPONENT_LIST';
export var GET_DATASETS_REQUEST = 'app/ColourPreview/GET_DATASETS_REQUEST';
export var GET_DATASETS_SUCCESS = 'app/ColourPreview/GET_DATASETS_SUCCESS';
export var GET_DATASETS_FAILURE = 'app/ColourPreview/GET_DATASETS_FAILURE';
export var GET_VIEWS_REQUEST = 'app/ColourPreview/GET_VIEWS_REQUEST';
export var GET_VIEWS_SUCCESS = 'app/ColourPreview/GET_VIEWS_SUCCESS';
export var GET_VIEWS_FAILURE = 'app/ColourPreview/GET_VIEWS_FAILURE';
export var CHANGE_VIEW_PADDING = 'app/ColourPreview/CHANGE_VIEW_PADDING';
export var TOGGLE_COMPONENT_EXCLUSIVE = 'app/ColourPreview/TOGGLE_COMPONENT_EXCLUSIVE';
export var SET_DATASET_SEPARATOR = 'app/ColourPreview/SET_DATASET_SEPARATOR';
export var SET_STICKY_HEADER = 'app/ColourPreview/SET_STICKY_HEADER';
export var CHANGE_DATASET_SEPARATOR_COLOR = 'app/ColourPreview/CHANGE_DATASET_SEPARATOR_COLOR';
export var CHANGE_DATASET_SEPARATOR_HEIGHT = 'app/ColourPreview/CHANGE_DATASET_SEPARATOR_HEIGHT';
export var TOGGLE_LIST_ITEM_BORDER = 'app/ColourPreview/TOGGLE_LIST_ITEM_BORDER';
export var SET_LIST_ITEM_BORDER_PROPERTY = 'app/ColourPreview/SET_LIST_ITEM_BORDER_PROPERTY';
export var RESET_DATASET_SEPARATOR = 'app/ColourPreview/RESET_DATASET_SEPARATOR';
export var ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER = 'app/ColourPreview/ENABLE_OVERRIDE_DATASET_LIST_GROUPING_HEADER';
export var CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS = 'app/ColourPreview/CHANGE_DATASET_LIST_GROUPING_HEADER_FIELDS';
export var RESET_DATASET_LIST_GROUPING_HEADER_FIELDS = 'app/ColourPreview/RESET_DATASET_LIST_GROUPING_HEADER_FIELDS';
export var SET_FULLSCREEN = 'app/ColourPreview/SET_FULLSCREEN';
export var SET_FLOW = 'app/ColourPreview/SET_FLOW';
export var TOGGLE_ORIENTATION = 'app/ColourPreview/TOGGLE_ORIENTATION';
export var TOGGLE_FONT_SCALLING = 'app/ColourPreview/TOGGLE_FONT_SCALLING';
export var RESET_LAYOUT = 'app/ColourPreview/RESET_LAYOUT';
export var CHANGE_COMPONENT_DIMENSIONS = 'app/ColourPreview/CHANGE_COMPONENT_DIMENSIONS';
export var GET_DATASET_ROWS_REQUEST = 'src/ColourPreview/GET_DATASET_ROWS_REQUEST';
export var GET_DATASET_ROWS_SUCCESS = 'src/ColourPreview/GET_DATASET_ROWS_SUCCESS';
export var GET_DATASET_ROWS_FAILURE = 'src/ColourPreview/GET_DATASET_ROWS_FAILURE';
export var SAVE_DATASET_NON_LIST_LAYOUT_REQUEST = 'src/ColourPreview/SAVE_DATASET_NON_LIST_LAYOUT_REQUEST';
export var SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS = 'src/ColourPreview/SAVE_DATASET_NON_LIST_LAYOUT_SUCCESS';
export var SAVE_DATASET_NON_LIST_LAYOUT_FAILURE = 'src/ColourPreview/SAVE_DATASET_NON_LIST_LAYOUT_FAILURE';
export var SAVE_LIST_VIEW_LAYOUT_REQUEST = 'src/ColourPreview/SAVE_LIST_VIEW_LAYOUT_REQUEST';
export var SAVE_LIST_VIEW_LAYOUT_SUCCESS = 'src/ColourPreview/SAVE_LIST_VIEW_LAYOUT_SUCCESS';
export var SAVE_LIST_VIEW_LAYOUT_FAILURE = 'src/ColourPreview/SAVE_LIST_VIEW_LAYOUT_FAILURE';
// multi state component constants
export var UPDATE_SELECTED_TAB = 'src/ColourPreview/ComponentProperties/UPDATE_SELECTED_TAB';
export var ADD_COMPONENT_STATE_SELECTED_COMPONENT = 'src/ColourPreview/ComponentProperties/ADD_COMPONENT_STATE_SELECTED_COMPONENT';
export var UPDATE_LOGIC_SELECETD_COMPONENT_STATE = 'src/ColourPreview/ComponentProperties/UPDATE_LOGIC_SELECETD_COMPONENT_STATE';
export var DELETE_COMPONENT_STATE = 'src/ColourPreview/ComponentProperties/DELETE_COMPONENT_STATE';
export var UPDATE_COMPONENT_STATE_NAME = 'src/ColourPreview/ComponentProperties/UPDATE_COMPONENT_STATE_NAME';
export var COPY_COMPONENT_STATE = 'src/ColourPreview/ComponentProperties/COPY_COMPONENT_STATE';
export var GET_DATASET_RULES_REQUEST = 'app/ColourPreview/GET_DATASET_RULES_REQUEST';
export var GET_DATASET_RULES_SUCCESS = 'app/ColourPreview/GET_DATASET_RULES_SUCCESS';
export var GET_DATASET_RULES_FAILURE = 'app/ColourPreview/GET_DATASET_RULES_FAILURE';
export var LOAD_STORAGE_REQUEST = 'app/ColourPreview/LOAD_STORAGE_REQUEST';
export var LOAD_STORAGE_SUCCESS = 'app/ColourPreview/LOAD_STORAGE_SUCCESS';
export var LOAD_STORAGE_FAILURE = 'app/ColourPreview/LOAD_STORAGE_FAILURE';
